<template>
  <div class="content-builder">

    <div class="form-group">
      <label for="video" class="control-label">Video</label>
      
      <div class="input-group">
        <div class="input-group-prepend">
          <a data-input="video" class="btn btn-primary text-white" data-lfm="file">
            <i class="fa fa-video-o"></i> Choose
          </a>
        </div>
        <input id="video" type="text" class="form-control" v-model.lazy="content.video">
      </div>
    </div>

  </div>
</template>

<script>
  import _ from 'lodash'
  import layoutMixin from '../../mixins/layout'

  export default {
    mixins: [layoutMixin],
    methods: {
      getValue() {
        this.content.video = $('#video').val();
        return this.content
      },
    }
  }
</script>
